import {AvailabilityStatus} from '@/typings/model';
import {TFunction} from "@/typings/common";

export function getOrderType(type: string | undefined, t: TFunction): string | null {
  switch (type) {
    case AvailabilityStatus.AVAILABLE:
      return t('orderType.in_stock');
    case AvailabilityStatus.ON_REQUEST:
      return t('orderType.to_order');
    case AvailabilityStatus.PRE_ORDER:
      return t('orderType.pre_order');
    case AvailabilityStatus.OUT_OF_ORDER:
      return t('orderType.out_of_stock');
    default:
      return null;
  }
}
